import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_PROMOTED_PETITIONS_USE_UNFILTERED_LIST = createFcmDetails(
	'promoted_petitions_use_unfiltered_list',
	{
		owner: 'Site Platform',
		context: 'promotion-service',
		import: false,
		description:
			'Specifies using the unfiltered list of promoted petitions instead of the paced list. The unfiltered list should be used in instances where there are an insufficient number of promoted petitions in the paced list.',
	},
);
